import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NoMessagesIcon = createIcon({
    viewBox: '0 0 52 52',
    path: (
        <>
            <Path
                d='M11.8211 28.9668C11.8211 28.5657 12.144 28.2405 12.5425 28.2405H31.299C31.6974 28.2405 32.0204 28.5657 32.0204 28.9668C32.0204 29.3679 31.6974 29.6931 31.299 29.6931H12.5425C12.144 29.6931 11.8211 29.3679 11.8211 28.9668Z'
                fill='currentColor'
            />
            <Path
                d='M11.8211 20.9779C11.8211 20.5768 12.144 20.2516 12.5425 20.2516H38.513C38.9114 20.2516 39.2344 20.5768 39.2344 20.9779C39.2344 21.379 38.9114 21.7041 38.513 21.7041H12.5425C12.144 21.7041 11.8211 21.379 11.8211 20.9779Z'
                fill='currentColor'
            />
            <Path
                d='M11.8211 12.9889C11.8211 12.5878 12.144 12.2627 12.5425 12.2627H38.513C38.9114 12.2627 39.2344 12.5878 39.2344 12.9889C39.2344 13.39 38.9114 13.7152 38.513 13.7152H12.5425C12.144 13.7152 11.8211 13.39 11.8211 12.9889Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.5009 36.106C10.1185 36.106 9.75785 36.2585 9.48372 36.5272L2.44281 43.5284V8.63133C2.44281 7.43299 3.4167 6.45253 4.61424 6.45253H46.4485C47.646 6.45253 48.6127 7.43299 48.6127 8.63133V34.0853C48.6127 35.5897 47.8082 36.0911 46.4485 36.0911C43.1084 36.0911 40.9547 36.106 37.6401 36.106H10.5009ZM50 34.0853V8.63133C50 6.62684 48.4395 5 46.4485 5H4.61424C2.61595 5 1 6.62684 1 8.63133V47L10.5009 37.5585H37.2145C41.4541 37.5585 42.0695 37.5585 46.4485 37.5585C46.8942 37.575 47.4393 37.5768 48 37.5737C49.1046 37.5676 50 36.6628 50 35.5582C50 35.1883 50 34.9544 50 34.0853Z'
                fill='currentColor'
            />
        </>
    ),
})

NoMessagesIcon.displayName = 'NoMessagesIcon'
